import { Suspense } from 'react'

import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { PrimeReactProvider } from 'primereact/api'

import GestionLayout from './Components/Layouts/GestionLayout'
import EntityLayout  from './Components/Layouts/EntityLayout'
import FrontLayout   from './Components/Layouts/FrontLayout'
import BackLayout    from './Components/Layouts/BackLayout'

import NotFoundPage from './Components/Errors/Pages/NotFoundPage'
import RouterError  from './Components/Errors/RouterError'

import SubFamilyPageLoader from './Components/Loaders/SubfamilyPageLoader'
import BrandsLogosLoader   from './Components/Loaders/BrandsLogosLoader'
import MyAccountLoader     from './Components/Loaders/MyAccountLoader'
import AdSectionLoader     from './Components/Loaders/AdSectionLoader'
import RechercheLoader     from './Components/Loaders/RechercheLoader'
import CommandeLoader      from './Components/Loaders/CommandeLoader'
import DemandeLoader       from './Components/Loaders/DemandeLoader'
import LayoutLoader        from './Components/Loaders/LayoutLoader'
import ClientLoader        from './Components/Loaders/ClientLoader'
import StatsLoader         from './Components/Loaders/StatsLoader'
import HomeLoader          from './Components/Loaders/HomeLoader'
import CartLoader          from './Components/Loaders/CartLoader'

import RootSpinner from './Components/Spinners/RootSpinner'

import AppVersion from './Components/Configs/AppVersion'

import ROUTES from './routes'

const prime_params = { ripple: true, unstyled: true };

const routes =
[
	{
		path: '*',
		errorElement: RouterError,
		element: <NotFoundPage error="Cette page n'existe pas." center />
	},

	{
		path: '/',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.HomePage,
				loader: HomeLoader
			},
			{
				path: 'mot-de-passe-oublie',
				lazy: ROUTES.RequestPasswordPage
			},
			{
				path: 'mot-de-passe-oublie/nouveau-mot-de-passe/:token',
				lazy: ROUTES.NewPasswordPage
			}
		]
	},

	{
		path: '/recherche',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: 'article-non-trouve',
				lazy: ROUTES.ArticleNotFoundPage
			},
			{
				path: ':searched',
				lazy: ROUTES.SearchResultPage,
				loader: RechercheLoader
			}
		]
	},

	{
		path: '/articles',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout className="front-stickable-page" />,

		children:
		[
			{
				path: ':article_subfamily',
				loader: SubFamilyPageLoader,
				lazy: ROUTES.SubfamilyPage
			}
		]
	},

	{
		path: '/espace-pro',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.EspaceProPage
			}
		]
	},

	{
		path: '/panier',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				loader: CartLoader,
				lazy: ROUTES.CartPage
			}
		]
	},

	{
		path: '/demande-ouverture-compte',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.DemandeOuverturePage
			}
		]
	},

	{
		path: '/infos-legales',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: 'cgu',
				lazy: ROUTES.CGUPage
			},
			{
				path: 'cgv',
				lazy: ROUTES.CGVPage
			},
			{
				path: 'pdc',
				lazy: ROUTES.PDCPage
			},
			{
				path: 'puc',
				lazy: ROUTES.PUCPage
			}
		]
	},

	{
		path: 'mon-compte',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <FrontLayout />,

		children:
		[
			{
				path: '',
				lazy: ROUTES.MyAccountPage,
				loader: MyAccountLoader
			},
			{
				path: 'commandes-et-devis',
				lazy: ROUTES.MyOrdersPage
			},
			{
				path: 'commandes-et-devis/:text_number',
				lazy: ROUTES.OrderDetailPage,
				loader: CommandeLoader
			}
		]
	},

	{
		path: 'entite',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <EntityLayout />,

		children:
		[
			{ path: 'BEROKI', lazy: ROUTES.BerokiPage },
			{ path: 'LTF', lazy: ROUTES.LTFPage },
			{ path: 'C2Clim', lazy: ROUTES.C2ClimPage }
		]
	},

	{
		path: '/admin',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <BackLayout />,

		children:
		[
			{
				path: 'accueil',
				lazy: ROUTES.AdminHomePage
			},
			{
				path: 'liste-des-logs',
				lazy: ROUTES.LogsListPage
			},
			{
				path: 'liste-des-utilisateurs',
				lazy: ROUTES.UsersListPage
			},
			{
				path: 'liste-des-utilisateurs/nouvel-utilisateur',
				lazy: ROUTES.NewUserPage
			},
			{
				path: 'liste-des-utilisateurs/:user_id',
				lazy: ROUTES.UserPage
			},
			{
				path: 'liste-des-utilisateurs/nouvel-utilisateur',
				lazy: ROUTES.NewUserPage
			}
		]
	},

 	{
		path: '/gestion',
		errorElement: RouterError,
		loader: LayoutLoader,
		element: <GestionLayout />,

		children:
		[
			{
				path: 'accueil',
				lazy: ROUTES.GestionHomePage,
				loader: StatsLoader
			},
			{
				path: 'liste-des-clients',
				lazy: ROUTES.ClientsListPage
			},
			{
				path: 'liste-des-clients/:client_id',
				lazy: ROUTES.ClientPage,
				loader: ClientLoader
			},
			{
				path: 'liste-des-clients/import-clients',
				lazy: ROUTES.ImportClientsPage
			},
			{
				path: 'liste-des-clients/import-contacts',
				lazy: ROUTES.ImportContactsPage
			},
			{
				path: 'liste-des-articles',
				lazy: ROUTES.ArticlesListPage
			},
			{
				path: 'liste-des-articles/import-articles',
				lazy: ROUTES.ImportArticlesPage
			},
			{
				path: 'liste-des-articles/delete-articles',
				lazy: ROUTES.DeleteArticlesPage
			},
			{
				path: 'liste-des-tarifs-particuliers',
				lazy: ROUTES.TarifsPPage
			},
			{
				path: 'liste-des-tarifs-particuliers/import-tarifs',
				lazy: ROUTES.ImportTarifsPPage
			},
			{
				path: 'liste-des-tarifs-particuliers/delete-tarifs',
				lazy: ROUTES.DeleteTarifsPPage
			},
			{
				path: 'liste-des-articles/import-tarifs',
				lazy: ROUTES.ImportTarifsGPage
			},
			{
				path: 'liste-des-demandes',
				lazy: ROUTES.DemandesListPage
			},
			{
				path: 'liste-des-demandes/:demande_id',
				lazy: ROUTES.DemandePage,
				loader: DemandeLoader
			},
			{
				path: 'liste-des-commandes',
				lazy: ROUTES.CommandesListPage
			},
			{
				path: 'liste-des-commandes/:text_number',
				lazy: ROUTES.CommandePage,
				loader: CommandeLoader
			},
			{
				path: 'liste-des-bannieres-pub',
				lazy: ROUTES.AdSectionsListPage
			},
			{
				path: 'liste-des-bannieres-pub/nouvelle-section',
				lazy: ROUTES.NewAdSectionPage
			},
			{
				path: 'liste-des-bannieres-pub/:id',
				lazy: ROUTES.EditAdSectionPage,
				loader: AdSectionLoader
			},
			{
				path: 'logos-marques',
				lazy: ROUTES.BrandsLogosEditPage,
				loader: BrandsLogosLoader
			}
		]
	}
];

const react_router_future =
{
	v7_startTransition: true,
	v7_relativeSplatPath: true,
	v7_fetcherPersist: true,
	v7_skipActionErrorRevalidation: true
};

const router = createBrowserRouter(routes,
{
	future: react_router_future
});

export default function App ()
{
	return (
		<PrimeReactProvider value={ prime_params }>

			<Suspense fallback={ <RootSpinner active /> }>
				<RouterProvider router={ router } future={ react_router_future } />
			</Suspense>

			<AppVersion />

		</PrimeReactProvider>
	);
}